import React from 'react'
import { Link } from 'react-router-dom'

const Faqs = () => {
    const faqs = [
        {
            id: 1,
            question: "What is Interactive?",
            answer: "Interactive is a software licensing company that gives artists, athletes, creators, and companies the ability easily put our Mixed Reality Ai technology (AR, QR, and more) in their products to increase fan engagement & data collection.",
            visible: false
        },
        {
            id: 2,
            question: "Who Is Interactive For?",
            answer: "Interactive is built for companies and creators of all sizes that want add value to their physical product. Trusted by artists and organizations like Louis Vuitton, Warner Music Entertainment, and Live Nation Entertainment, we enhance fan experiences by enabling the addition of interactive elements such as transforming images, embedded videos, and informational overlays. ",
            visible: false
        },
        {
            id: 3,
            question: "What content can be included in Mixed Reality Ai formats? ",
            answer: "Videos, audio, photo slideshows, call to action button web-based URLs, text, email contact, maps, donations, music stream purchases and much more. Videos must be under 400mb and no longer than 4 minutes and submitted as .mp4, .avi, or .wav file",
            visible: false
        },
        {
            id: 4,
            question: "Do you sell physical products or only the technology?",
            answer: "We can assist with select physical products such as laminates, posters, tour books and trading cards through our partnership with the top print vendors in the USA. Customers who order these products directly through our team receive a discount vs only purchasing the technology. ",
            visible: false
        },
        {
            id: 5,
            question: "How long will the content be active?",
            answer: "An AR-QR code or interactive image via customized mobile app is active for 5 years. For custom use cases this can be extended. After 5 years, the AR experience will not load, and users will instead be directed to the video content via URL. This ensures the content will never fully expire or be lost.",
            visible: false
        },
    ]

    const [currentFaqs, setCurrentFaqs] = React.useState(faqs)

    const handleFaqs = (id) => {
        setCurrentFaqs(currentFaqs.map(faq => {
            if (faq.id === id) {
                return {
                    ...faq,
                    visible: !faq.visible
                }
            }
            return faq
        }))
    }
    return (
        <div className='faqs py-20'>
            <div className="container mx-auto">
                <div className="flex lg:flex-row flex-col justify-between items-start">
                    <div className="left w-full lg:w-[40%]">
                        <h2 className='text-[30px] lg:text-[40px] font-bold mb-10' style={{ lineHeight: '1.2' }}>
                            Frequently Asked <br /> Questions
                        </h2>
                        <Link to='/faqs' className='text-white bg-black lg:inline hidden border uppercase px-4 py-3 rounded-[6px] font-semibold'>
                            See More
                        </Link>
                    </div>
                    <div className="right w-full lg:w-[50%]">
                        {
                            currentFaqs.map(faq => (
                                <div key={faq.id} className='faq mb-5'>
                                    <div className="question font-semibold text-lg flex justify-between items-center cursor-pointer" onClick={() => handleFaqs(faq.id)}>
                                        <span>{faq.question}</span>
                                        <span className='text-[#172B85] text-xl'>{faq.visible ? '-' : '+'}</span>
                                    </div>
                                    {faq.visible && (
                                        <div className="answer text-sm mt-2">
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Faqs